// extracted by mini-css-extract-plugin
module.exports = {"quote":"styles_quote__2H8iI","about":"styles_about__27Ci0"};